module.exports = __webpack_public_path__ + "static/media/starts_with_l.e93e1831.mp3";